'use client'

import { useEffect } from 'react'
import { useCustomRouter } from '@/root/shared-hooks/useCustomRouter/useCustomRouter'
import { usePrintedTicketData } from '@/root/shared-hooks/reservation/usePrintedTicketData'
import type { Reservation } from '@/root/shared-types/reservation/reservation-types'
import { getTicketPageView } from '../helpers/getTicketPageView'

/** Ticket page state for every client: the ticket data, which view to show and which actions are allowed. */
export const useTicketPage = (staticReservation: Reservation) => {
  const { push, locale } = useCustomRouter()
  const { reservation: ticketData } = usePrintedTicketData(staticReservation)
  const status = ticketData?.status

  // An unconfirmed reservation has no ticket yet
  useEffect(() => {
    if (status === 'TEMP') {
      push(`/${locale}`)
    }
  }, [push, status, locale])

  if (!ticketData) return null

  const pageState = getTicketPageView(ticketData, staticReservation.allowance)

  return pageState && { ticketData, ...pageState }
}
